// extracted by mini-css-extract-plugin
export default {"form":"ManualAddPhone_form__+k7r+"};